import React, { useCallback } from 'react';
import { Input } from 'antd';
import type { InputProps } from 'antd';
import { normalizePostalCode } from '../../utils/normalizeNumber';

/**
 * 郵便番号入力用のカスタムInput
 *
 * @description
 * 全角数字・ハイフンを自動的に半角に変換します。
 * 日本の郵便番号（XXX-XXXX形式）の入力に使用します。
 *
 * @example
 * <Form.Item name="postalCode" rules={[postalCodeRule()]}>
 *   <PostalCodeInput placeholder="123-4567" />
 * </Form.Item>
 */
export const PostalCodeInput: React.FC<InputProps> = ({
  onChange,
  ...props
}) => {
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const originalValue = e.target.value;
      const normalizedValue = normalizePostalCode(originalValue);

      // 正規化した値で新しいイベントを作成
      const newEvent = {
        ...e,
        target: {
          ...e.target,
          value: normalizedValue,
        },
      } as React.ChangeEvent<HTMLInputElement>;

      onChange?.(newEvent);
    },
    [onChange]
  );

  return <Input {...props} onChange={handleChange} />;
};

export default PostalCodeInput;
